import React from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import './button.scss';

const ButtonComponent = ({
  label,
  onClick,
  variant,
  btnCss,
  endIcon,
  startIcon,
  id = 'click-action-button',
  disabled = false,
  sx,
}) => {
  return (
    <Button
      variant={variant}
      className={`common-button ${btnCss}`}
      onClick={onClick}
      endIcon={endIcon}
      startIcon={startIcon}
      id={id}
      disabled={disabled}
      sx={sx}
    >
      {label}
    </Button>
  );
};

ButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.any.isRequired,
  variant: PropTypes.string,
  btnCss: PropTypes.string,
  endIcon: PropTypes.element,
  startIcon: PropTypes.element,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};

export default ButtonComponent;
